import { useHistory, useParams } from "react-router";
import "../material-details.scss";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import { ProjectPermissionEnum } from "constants/index";
import { FeatureTypes } from "entity-app/constants";
import useFeatureLogNavReader from "hooks/use-feature-log-nav-reader";
import MaterialDetailCards from "./material-details-cards";
import FeatureHeader from "./material-header/material-header";
import usePageTitle from "hooks/use-page-title";
import { formatEntityTitle } from "config/page-titles";

function FeatureMaterialDetails() {
  const history = useHistory();
  const { projectId, materialId } = useParams() as any;
  const { tokenContents } = useContext(ProjectContext);

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    materialId,
    FeatureTypes.MATERIALS
  );

  usePageTitle(
    formatEntityTitle(
      featureInstanceData?.auto_inc_value,
      featureInstanceData?.title
    )
  );

  const cannotWriteAccessOfMaterial = isPermissionNotGrantted(
    ProjectPermissionEnum.CreateMaterial,
    tokenContents?.role ?? ""
  );

  const navigator = useFeatureLogNavReader({
    feature: "materials",
    projectId,
    currentId: materialId
  });

  const goBackToList = () => {
    history.push(`/project/${projectId}/materials`);
  };

  return (
    <div
      className="grow flex-col bg-ciq-gray-50"
      data-testid="feature-material-details-root"
    >
      <FeatureHeader
        featureInstanceData={featureInstanceData}
        title="Material Details"
        subTitle=""
        actions={actions}
        number={featureInstanceData?.auto_inc_value}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfMaterial}
        goBackToList={goBackToList}
        feature="MATERIALS"
        navigator={navigator}
        data-testid="feature-material-details-header"
      />
      <MaterialDetailCards
        key={materialId}
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={materialId}
        data-testid="feature-material-details-cards"
      />
    </div>
  );
}

export default FeatureMaterialDetails;
